export const version = '1.1.7';
//# sourceMappingURL=version.js.map